'use strict';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Assert = require('@hapi/hoek/lib/assert');
var AssertError = require('@hapi/hoek/lib/error');
var Pkg = require('../package.json');
var Messages;
var Schemas;
var internals = {
  isoDate: /^(?:[-+]\d{2})?(?:\d{4}(?!\d{2}\b))(?:(-?)(?:(?:0[1-9]|1[0-2])(?:\1(?:[12]\d|0[1-9]|3[01]))?|W(?:[0-4]\d|5[0-2])(?:-?[1-7])?|(?:00[1-9]|0[1-9]\d|[12]\d{2}|3(?:[0-5]\d|6[1-6])))(?![T]$|[T][\d]+Z$)(?:[T\s](?:(?:(?:[01]\d|2[0-3])(?:(:?)[0-5]\d)?|24\:?00)(?:[.,]\d+(?!:))?)(?:\2[0-5]\d(?:[.,]\d+)?)?(?:[Z]|(?:[+-])(?:[01]\d|2[0-3])(?::?[0-5]\d)?)?)?)?$/
};
exports.version = Pkg.version;
exports.defaults = {
  abortEarly: true,
  allowUnknown: false,
  cache: true,
  context: null,
  convert: true,
  dateFormat: 'iso',
  errors: {
    escapeHtml: false,
    label: 'path',
    language: null,
    render: true,
    stack: false,
    wrap: {
      label: '"',
      array: '[]'
    }
  },
  externals: true,
  messages: {},
  nonEnumerables: false,
  noDefaults: false,
  presence: 'optional',
  skipFunctions: false,
  stripUnknown: false,
  warnings: false
};
exports.symbols = {
  any: Symbol.for('@hapi/joi/schema'),
  // Used to internally identify any-based types (shared with other joi versions)
  arraySingle: Symbol('arraySingle'),
  deepDefault: Symbol('deepDefault'),
  literal: Symbol('literal'),
  override: Symbol('override'),
  prefs: Symbol('prefs'),
  ref: Symbol('ref'),
  values: Symbol('values'),
  template: Symbol('template')
};
exports.assertOptions = function (options, keys) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Options';
  Assert(options && typeof options === 'object' && !Array.isArray(options), 'Options must be of type object');
  var unknownKeys = Object.keys(options).filter(function (k) {
    return !keys.includes(k);
  });
  Assert(unknownKeys.length === 0, "".concat(name, " contain unknown keys: ").concat(unknownKeys));
};
exports.checkPreferences = function (prefs) {
  Schemas = Schemas || require('./schemas');
  var result = Schemas.preferences.validate(prefs);
  if (result.error) {
    throw new AssertError([result.error.details[0].message]);
  }
};
exports.compare = function (a, b, operator) {
  switch (operator) {
    case '=':
      return a === b;
    case '>':
      return a > b;
    case '<':
      return a < b;
    case '>=':
      return a >= b;
    case '<=':
      return a <= b;
  }
};
exports.default = function (value, defaultValue) {
  return value === undefined ? defaultValue : value;
};
exports.isIsoDate = function (date) {
  return internals.isoDate.test(date);
};
exports.isNumber = function (value) {
  return typeof value === 'number' && !isNaN(value);
};
exports.isResolvable = function (obj) {
  if (!obj) {
    return false;
  }
  return obj[exports.symbols.ref] || obj[exports.symbols.template];
};
exports.isSchema = function (schema) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var any = schema && schema[exports.symbols.any];
  if (!any) {
    return false;
  }
  Assert(options.legacy || any.version === exports.version, 'Cannot mix different versions of joi schemas');
  return true;
};
exports.isValues = function (obj) {
  return obj[exports.symbols.values];
};
exports.limit = function (value) {
  return Number.isSafeInteger(value) && value >= 0;
};
exports.preferences = function (target, source) {
  Messages = Messages || require('./messages');
  target = target || {};
  source = source || {};
  var merged = Object.assign({}, target, source);
  if (source.errors && target.errors) {
    merged.errors = Object.assign({}, target.errors, source.errors);
    merged.errors.wrap = Object.assign({}, target.errors.wrap, source.errors.wrap);
  }
  if (source.messages) {
    merged.messages = Messages.compile(source.messages, target.messages);
  }
  delete merged[exports.symbols.prefs];
  return merged;
};
exports.tryWithPath = function (fn, key) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  try {
    return fn();
  } catch (err) {
    if (err.path !== undefined) {
      err.path = key + '.' + err.path;
    } else {
      err.path = key;
    }
    if (options.append) {
      err.message = "".concat(err.message, " (").concat(err.path, ")");
    }
    throw err;
  }
};
exports.validateArg = function (value, label, _ref) {
  var assert = _ref.assert,
    message = _ref.message;
  if (exports.isSchema(assert)) {
    var result = assert.validate(value);
    if (!result.error) {
      return;
    }
    return result.error.message;
  } else if (!assert(value)) {
    return label ? "".concat(label, " ").concat(message) : message;
  }
};
exports.verifyFlat = function (args, method) {
  var _iterator = _createForOfIteratorHelper(args),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var arg = _step.value;
      Assert(!Array.isArray(arg), 'Method no longer accepts array arguments:', method);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};